import { FC } from "react";

export const PageLoader: FC = () => (
  <div className="page-loader flex-column">
    <div className="d-flex align-items-center mt-5">
      <span className="spinner-border text-primary" role="status"></span>
      <span className="text-muted fs-6 fw-bold ms-5">Carregando…</span>
    </div>
  </div>
);
